import React, { useRef, useState, useEffect } from 'react';
import IdleTimer from 'react-idle-timer';
import { useSelector } from 'react-redux';
import { isEqual } from 'lodash';
import Confirmation from 'components/ui/ConfirmationDialog/ConfirmationDialog';
import { useTranslation } from 'react-i18next';
import { getCurrentRecordingState } from 'config/helpers/recordingStateSelector';

const IdleController = (props) => {

  const timeout = 1000 * 60 * 60; // 60 mins
  const warningTime = 1000 * 30; // 30 seconds before logout

  
  const patientId = useSelector((state) => state.patientObj?.patientObj?.id);
  const encounterId = useSelector((state) => state.encounterObj?.encounter?.id);

  const { recording, paused } = useSelector((state) =>
    getCurrentRecordingState(state, patientId, encounterId)
  );
  const auth = useSelector((state) => state?.auth, isEqual);
  const { i18n } = useTranslation();

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [secondsRemaining, setSecondsRemaining] = useState(30); // Default warning time
  const idleTimerRef = useRef();
  const endTimeRef = useRef(null);
  const backgroundTasks = useSelector((state) => state.backgroundTasks.tasks);

  const isBackgroundTasks = backgroundTasks.some(
    (t) => t.status === "IN_PROGRESS" || t.status === "PENDING"
  );

  const handleOnIdle = () => {
    if (!(recording || paused || isBackgroundTasks) && !isPopupOpen) {
      endTimeRef.current = Date?.now() + warningTime; // Setting the exact end time
      setSecondsRemaining(Math?.floor(warningTime / 1000));
      setIsPopupOpen(true);
    }
  };

  const handleStayLoggedIn = () => {
    setIsPopupOpen(false);
    idleTimerRef?.current?.reset(); // Resetting the idle timer to start from zero
  };

  const handleLogout = () => {
    setIsPopupOpen(false);
    props?.handleLogout();
  };

  useEffect(() => {
    let countdown;

    if (isPopupOpen) {
      countdown = setInterval(() => {
        const timeLeft = Math?.max(0, Math.floor((endTimeRef?.current - Date?.now()) / 1000));
        setSecondsRemaining((prev) => (prev !== timeLeft ? timeLeft : prev));

        if (timeLeft <= 0) {
          clearInterval(countdown);
          handleLogout();
        }
      }, 1000);
    }

    return () => {
      clearInterval(countdown);
    };
  }, [isPopupOpen]);

  if (!auth?.isUserLoggedIn) {
    return null;
  }

  return (
    <>
      <IdleTimer ref={idleTimerRef} timeout={timeout} onIdle={handleOnIdle} debounce={250} />
      <Confirmation
        open={isPopupOpen}
        setOpen={setIsPopupOpen}
        // cancelText="common.STAY_LOGGED_IN"
        cancelText="common.CONTINUE"
        cancelFunction={handleStayLoggedIn}
        callback={handleLogout}
        type="logout"
        title={i18n?.t('common.SESSION_TIMEOUT_WARNING')}
        // message={`${i18n?.t('common.USER_INACTIVITY_MESSAGE')} ${secondsRemaining} ${
        //   secondsRemaining === 1 ? i18n?.t('common.SECOND') : i18n?.t('common.SECONDS')
        // }.`}
        message={i18n?.t('common.LOGOUT_WARNING_MESSAGE',{inactivityTime:10,warningTime:secondsRemaining})}
        okText="tooltips.LOGOUT"
        exitButtonLoading={props.exitButtonLoading}
      />
    </>
  );
};

export default IdleController;
